import React from "react";

const toneClasses = {
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  error: "border-rose-200 bg-rose-50 text-rose-700",
  warning: "border-amber-200 bg-amber-50 text-amber-800",
  info: "border-blue-200 bg-blue-50 text-blue-700",
};

const Alert = ({ children, tone = "info", className = "" }) => {
  return (
    <div
      className={[
        "rounded-lg border px-4 py-3 text-sm",
        toneClasses[tone] || toneClasses.info,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
};

export default Alert;
